import React, { useEffect } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Header from '../../components/Header/Header';
import HomePage from '../../components/HomePage/HomePage';
import AboutPage from '../../components/AboutPage/AboutPage';
import Footer from '../../components/Footer/Footer';
import JoinUs from '../../components/JoinUs/JoinUs';
import Work from '../../components/Work/Work';
import KeyFeature from '../../components/KeyFeature/KeyFeature';
import Team from '../../components/Team/Team';
import Blog from '../../components/Blog/Blog';
import Testimonial from '../../components/Testimonial/Testimonial';
import Category from '../../components/Category/Category';
import { createVisit } from '../../API/Api';

const Home = () => {
 useEffect(() => {
    const alreadyVisited = sessionStorage.getItem('visited_home');

    if (!alreadyVisited) {
      createVisit({ page: 'home' })
        .then(() => {
          sessionStorage.setItem('visited_home', 'true');
        })
        .catch((err) => {
          console.error('Visit tracking failed:', err);
        });
    }
  }, []);

  return (
    <div >
      {/* <Navbar />
      <Header /> */}
      <HomePage />
      <AboutPage />
      <JoinUs />
      <Work />
      <KeyFeature />
      <Team />
      <Category />
      <Testimonial />
      <Blog />
      {/* <Footer /> */}
    </div>
  );
}

export default Home;
